import React, {useContext} from 'react';
import {Button, Descriptions, Space} from 'antd';
import {observer} from "mobx-react";
import {CardStyled} from "../../../components/styled/card.styled";
import {useLoaderData, useNavigate} from "react-router-dom";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import AccessUtil from "../../../components/util/access.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {StoreContext} from "../../../store.context";
import {Helmet} from "react-helmet-async";

export const View: React.FC = observer(() => {
    const { appStore: { translate } } = useContext(StoreContext);
    const translationDomain = TranslationDomainEnum.USER_ADMINISTRATION;
    const title = translate('role.title.roles', {}, translationDomain);

    const data: any = useLoaderData();
    const navigate = useNavigate();

    return (
            <>
                <Helmet>
                    <title>{`CL BO - ${title} - ${data?.name}`}</title>
                </Helmet>
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <CardStyled title={`View`}>
                <div style={{ padding: '16px', paddingBottom: 0 }}>
                    <Space direction={`vertical`} style={{ display: 'flex' }}>
                        <Descriptions bordered>
                            <Descriptions.Item label={<Translate message={`role.field.id`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.id }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`role.field.name`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.name }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`role.field.description`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.description }</Descriptions.Item>
                            <Descriptions.Item label={<Translate message={`role.field.level`} domain={TranslationDomainEnum.USER_ADMINISTRATION} />} span={3}>{ data.level }</Descriptions.Item>
                        </Descriptions>
                    </Space>
                </div>
            </CardStyled>

            <ButtonBar>
                <AccessUtil access={{ routeName: 'role_edit', attributes: [{ id: data.id }]}}>
                    <Button type="primary" onClick={ () => navigate(`/role/${data.id}/edit`) }>
                        <Translate message={`global.button.edit`} />
                    </Button>
                </AccessUtil>
                <Button type="primary" className={`ant-btn-secondary`} onClick={ () => navigate(`/role`) }>
                    <Translate message={`global.button.back_to_list`} />
                </Button>
            </ButtonBar>
        </Space>
            </>
    )
})